export default __webpack_public_path__ + "static/media/infra-11.b4ee38b3.webp";